<template>
<div>
  <btn @click="importSheets">Fichier Néocat</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <h2>Import Néo Inf ADI  - Néocat</h2>
    <div class="row">
      <div class="col-xs-12">
        <p>
          <input ref="fileInput" type="file" single>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
      </div>
    </div>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
  <modal v-model="ufs.modal"
         :backdrop="false"
         :dismiss-btn="false"
         :keyboard="false"
         title="Association des Ufs">
    <div class="form-group"
         v-for="(u, k) in ufs.list"
         :key="`import-rezo-uf-${k}`">
      <label for="`import-rezo-uf-${k}-name`">Code service {{ u }}</label>
      <select v-model="ufs.result[u]"
              class="form-control">
        <option disabled value="">Uf associée</option>
        <option v-for="(v, j) in availableUfs"
                :value="v"
                :key="`import-rezo-uf-${k}-av-${j}`">
          {{ v.name }} ({{ v.typename }})
        </option>
      </select>
    </div>
    <collapse v-model="ufs.error.show">
      <alert type="danger">
        <strong>{{ ufs.error.title }}</strong>
        <p v-for="(e, i) in ufs.error.texts" :key="i">{{ e }}</p>
      </alert>
    </collapse>
    <div slot="footer">
      <btn @click="checkUfs" type="primary">Confirmer</btn>
    </div>
  </modal>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'
import steps from '@/sui/components/steps'
import baseSteps from '@/components/sheets/import/impl/steps'
import neocat from '@/components/sheets/import/impl/neocat'
import impl from '@/components/sheets/import/impl/neoinfadi'
import units from '@/sui/data/units'
import validator from '@/sui/components/sheet/validate/impl/validator'
import types from '@/sui/data/modules'
import assert from '@/sui/tools/assert'

export default {
  name: 'sheets-import-neocat',
  props: {
    surveillance: {
      type: Object,
      required: true
    }
  },

  data: function () {
    const steps = [
      baseSteps.load(
        'Fichier Néocat', 'Impossible de charger le fichier'
      ),
      baseSteps.transform(
        'Ajout des patients via les cathéters',
        'Impossible de traiter le fichier Néocat',
        (count) => `${count} cathéters traitées avec succès.`,
        (vm, data, o, start, end) => {
          if (start === 0) {
            data.prepared = {}
            data.units = []
            data.surveillanceYear = this.surveillance.year
          }

          for (let i = start; i !== end; ++i) {
            const code = o[i].codenn
            let sheet = data.prepared[code]
            if (sheet == null) {
              data.prepared[code] = o[i]
              sheet = o[i]
              sheet.service = 'A'
              if (data.units.indexOf(sheet.service) === -1) {
                data.units.push(sheet.service)
              }
            }
            neocat.prepare(o[i], sheet)
          }
        }
      ),
      {
        title: 'Sélection des Ufs',
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            vm.showUfsModal(data.units)
          }

          if (!vm.ufs.modal && !vm.ufs.error.show) {
            for (let i in data.prepared) {
              const sheet = data.prepared[i]
              const unit = vm.ufs.result[sheet.service.toString()]
              sheet.unitType = unit.typename
              sheet.uf = unit.name
            }
            return { end: true, success: true }
          }
          return { end: !vm.ufs.modal, success: !vm.ufs.error.show }
        },

        setError: function (e) {
          return `Erreur lors de l'association des Ufs avec les codes services : ${e}.`
        }
      },
      {
        index: 0,
        title: 'Ajout des patients',
        prepared: null,

        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.index = 0
            this.prepared = []
            for (let i in data.prepared) {
              const sheet = data.prepared[i]
              this.prepared.push(sheet)
            }
          }
          try {
            const o = this.prepared
            const max = o.length
            const step = 100
            const end = this.index + step >= max ? max : this.index + step
            this.transform(vm, data, o, this.index, end)
            this.index = end
          } catch (e) {
            return {
              end: true,
              success: false,
              error: `Fichier invalide: ${e}.`
            }
          }

          if (this.index === this.prepared.length) {
            return {
              end: true,
              success: true,
              msg: `${this.prepared.length} patients ajoutés avec succès.`
            }
          }

          return { end: false }
        },

        transform: function (vm, data, o, start, end) {
          if (start === 0) {
            data.sheets = {}
            vm.d = []
            const module = types.get(data.surveillanceYear)['neoInfADI']
            assert.notNull(
              module,
              `selectReference: invalid sheet type (${this.module})`
            )
            vm.reference = module.sheets.edit
          }

          for (let i = start; i !== end; ++i) {
            const transformed = impl.createSheet(data.surveillanceYear, o[i])
            data.sheets[i] = transformed
            vm.d.push({ f: transformed, t: 'neoInfADI', y: data.surveillanceYear })
          }
        },

        setError: function (e) {
          return `Neocat error : ${e}`
        }
      },
      validator.steps.validate(vm => vm.d, true),
      baseSteps.purge('neoInfADI'),
      baseSteps.insert('neoInfADI')
    ]

    return {
      show: false,
      iterator: new StepIterator(steps),
      ufs: {
        modal: false,
        result: {},
        list: [],
        error: {
          show: false,
          texts: [],
          title: ''
        }
      }
    }
  },

  computed: {
    unitTypes: function () {
      return units['2023'].neoAndMix
    },
    completed: function () {
      return this.iterator.completed
    },

    availableUfs: function () {
      if (this.surveillance == null) {
        return []
      }

      const result = []
      const rea = this.surveillance.modules.neoInfADI.ufs
      rea.forEach(
        (r) => {
          const typename = this.unitTypes.find((e) => e.index === r.ufType).code
          result.push({ type: r.ufType, typename: typename, name: r.name })
        }
      )
      return result
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    importSheets: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    },

    setError: function (title, texts) {
      this.ufs.error.show = true
      this.ufs.error.title = title
      this.ufs.error.texts = texts
    },

    checkUfs: function () {
      const ufs = []
      for (let i in this.ufs.list) {
        const s = this.ufs.list[i]
        const r = this.ufs.result[s]
        if (r == null) {
          this.setError(
            'Attention !',
            [ 'Toutes les codes services doivent être associés.' ]
          )
          return
        } else if (ufs.indexOf(r) !== -1) {
          this.setError(
            'Attention !',
            [ 'Une Uf ne peut être utilisée que pour un seul code service.' ]
          )
          return
        } else {
          ufs.push(r)
        }
      }
      this.ufs.modal = false
    },

    showUfsModal: function (units) {
      this.ufs.error.show = false
      this.ufs.list = units
      this.ufs.result = []
      this.ufs.modal = true
    }
  },

  components: {
    'steps': steps
  }
}
</script>
<style lang="less" scoped>
</style>
